import { render, staticRenderFns } from "./WorkflowRunList.vue?vue&type=template&id=b3713e9e"
import script from "./WorkflowRunList.vue?vue&type=script&lang=js"
export * from "./WorkflowRunList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports